import { render, staticRenderFns } from "./ProductItemImage.vue?vue&type=template&id=59fe9359&"
import script from "./ProductItemImage.vue?vue&type=script&lang=js&"
export * from "./ProductItemImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports